export enum MaskedValueVariant {
  TEXT = 'TEXT',
  DECIMAL = 'DECIMAL',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  PERCENTAGE = 'PERCENTAGE',
}
